
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycabserviceinmumbai() {



const cardData =
{
  keyword: 'Monthly Cab Service in Mumbai',
  heading: 'eTravo: Monthly Cab Service in Mumbai for Corporates and Professionals',
  headingDescription: 'eTravo provides premium and flexible monthly cab rental services in Mumbai for corporates, startups, and business professionals. Whether you need long-term cab hire for employee commutes, executive travel, or airport transfers, our plans are designed to ensure convenience, reliability, and affordability. With a wide fleet ranging from hatchbacks to luxury sedans and SUVs, our monthly packages come with trained chauffeurs, GPS tracking, customizable routes, and transparent billing. eTravo is your trusted transport partner in Mumbai, helping businesses streamline their mobility needs without the hassle of daily bookings.',

  top: 'Top Business Locations in Mumbai Served by Monthly Cab Services',
  topPlaces: [
    {
      title: 'Bandra Kurla Complex (BKC)',
      description: 'One of Mumbai’s most prestigious commercial hubs, housing major banks, corporate HQs, and global consulates. eTravo’s monthly cab plans are widely used by executives and office staff commuting daily to BKC, ensuring smooth, air-conditioned rides amid the city’s traffic.'
    },
    {
      title: 'Andheri East',
      description: 'A busy business district with corporate offices, studios, and tech parks. Our monthly cab services here are preferred for shift-based employee transport and all-day executive mobility, including travel to nearby suburbs and the airport.'
    },
    {
      title: 'Nariman Point',
      description: 'A historic financial and business center of South Mumbai. eTravo’s executive cab rentals are frequently used for boardroom travel, daily staff pickups, and long-term client mobility for companies based in this premium area.'
    },
    {
      title: 'Lower Parel',
      description: 'Home to luxury offices and coworking hubs, Lower Parel demands stylish and dependable transport. Our monthly subscriptions support executives and founders traveling between meetings, events, and outstation hubs.'
    },
    {
      title: 'Powai (Hiranandani Business Park)',
      description: 'A growing tech and startup ecosystem where daily team movement is crucial. eTravo’s monthly cab plans for Powai include flexible scheduling, live tracking, and chauffeur reliability for IT firms and venture-backed startups.'
    },
    {
      title: 'Malad & Goregaon (Mindspace and Infinity IT Park)',
      description: 'Major residential-commercial zones where companies prefer affordable, long-term cab arrangements for daily staff shuttles and office commutes. Our services include air-conditioned cabs with trained, verified drivers.'
    },
    {
      title: 'Fort (Mumbai CST Zone)',
      description: 'Known for law firms, heritage offices, and high-profile consultancies. Our monthly cab service supports quick and professional transport for legal teams, auditors, and finance professionals.'
    },
    {
      title: 'Thane Ghodbunder Road',
      description: 'A popular location for IT parks and BPOs with significant daily staff movement. Our monthly cabs run fixed routes with multiple pickup points, helping companies ensure punctuality and comfort for large teams.'
    },
    {
      title: 'Seepz Andheri MIDC',
      description: 'An industrial and IT hub requiring dependable cab transport for office staff, tech consultants, and shift employees. eTravo provides dedicated monthly cabs for single.'
    },
    {
      title: 'Mumbai International Airport (Sahar Terminal)',
      description: 'For businesses relying on frequent air travel, our monthly airport cab service offers 24/7 availability, real-time flight tracking, and luxury cab options with airport formalities in mind.'
    }
  ],

  services: [
    {
      name: 'Mumbai Corporate Monthly Cab Hire',
      description: 'Ideal for medium to large businesses needing ongoing transportation for their executives and employees. Our corporate monthly cab hire ensures that your team members have dedicated vehicles without the daily coordination hassle, with fixed monthly invoicing and flexible route management.'
    },
    {
      name: 'Long-Term Employee Cab Rentals Mumbai',
      description: 'Designed for HR teams managing workforce transport, this service includes fixed cab schedules, shift-specific routing, and driver duty rotation. We manage the full transport loop—pickup, drop, tracking, and support—under long-term, low-maintenance plans.'
    },
    {
      name: 'Business Monthly Cab Service Mumbai',
      description: 'Our business packages are ideal for startups, consultants, or client-facing teams. Each vehicle is maintained for maximum comfort and uptime, offering quiet cabins, corporate billing, and daily availability for meetings, branch visits, or presentations.'
    },
    {
      name: 'Affordable Monthly Corporate Cabs Mumbai',
      description: 'Get city-wide monthly cab service at a price that fits your corporate travel budget. We offer AC hatchbacks, sedans services for daily use, supported by reliable drivers and round-the-clock response teams.'
    },
    {
      name: 'Reliable Corporate Cab Hire Mumbai',
      description: 'Known for its punctuality and consistency, eTravo’s monthly cab hire includes backup vehicles, GPS monitoring, trip logs, and vehicle replacements in case of breakdowns—ensuring uninterrupted service even in emergencies.'
    },
    {
      name: 'Monthly Staff Commute Mumbai',
      description: 'Especially suitable for companies in Mindspace, Seepz, or BKC, this plan helps employees commute comfortably in AC cabs every day. Pickup points and timing are optimized in advance to prevent delays and improve attendance.'
    },
    {
      name: 'Executive Monthly Cab Service Mumbai',
      description: 'Designed for CXOs, consultants, and partners who need luxury-grade vehicles for daily travel. Our executive cabs include Toyota Camry, Innova Crysta, and Honda City with business-class interiors and trained chauffeurs.'
    },
    {
      name: 'Monthly Business Cab Rentals Mumbai',
      description: 'Manage daily branch visits, logistics runs, or on-ground client servicing without worry. These rental plans are scalable and can be combined with airport drops, weekend outstation trips, or intercity meetings.'
    },
    {
      name: 'Corporate Lease Cab Mumbai',
      description: 'For enterprises that want to reduce capital expenses, our lease model includes all-inclusive cab services with registration, maintenance, insurance, and driver costs covered—ideal for operations teams and salesforces.'
    },
    {
      name: 'Monthly Airport Transfer Mumbai',
      description: 'Includes early morning pickups, red-eye drops, flight tracking, and priority drop lanes. Corporates with international dealings can rely on our airport subscription cabs for smooth transitions from office to terminal.'
    },
    {
      name: 'Monthly Cab for Employee Transport Mumbai',
      description: 'Great for BPOs, IT firms, and back-office units operating across shifts. Cabs are assigned based on employee clusters, with a dedicated fleet manager monitoring trip safety and performance.'
    },
    {
      name: 'Monthly VIP Cab Mumbai',
      description: 'Give your guests or directors a premium mobility experience in Mumbai with luxury sedans and professional chauffeurs. Cab interiors include privacy partitions, premium upholstery, and cold beverages upon request.'
    },
    {
      name: 'Corporate Subscription Cab Mumbai',
      description: 'Simplify transportation with a subscription model that allows your company to pre-book recurring services. You get fixed monthly rates, priority bookings, and instant replacements without renegotiation.'
    },
    {
      name: 'Flexible Monthly Cab Plans Mumbai',
      description: 'We understand dynamic schedules—modify routes, vehicle types, or usage hours mid-plan as needed. Our dashboard-based reporting helps you track usage, optimize costs, and forecast your transport needs.'
    },
    {
      name: 'Long-Term Cab Service Mumbai',
      description: 'Meant for year-round, full-day usage where one or more cabs are assigned to company departments or executives. These plans include dedicated drivers and extended service hours, ideal for operations-intensive businesses.'
    }
  ],

  tableData: [
    ['Mumbai Corporate Monthly Cab Hire', 'Long-Term Employee Cab Rentals Mumbai'],
    ['Business Monthly Cab Service Mumbai', 'Affordable Monthly Corporate Cabs Mumbai'],
    ['Reliable Corporate Cab Hire Mumbai', 'Monthly Staff Commute Mumbai'],
    ['Executive Monthly Cab Service Mumbai', 'Monthly Business Cab Rentals Mumbai'],
    ['Corporate Lease Cab Mumbai', 'Monthly Airport Transfer Mumbai'],
    ['Monthly Cab for Employee Transport Mumbai', 'Monthly VIP Cab Mumbai'],
    ['Corporate Subscription Cab Mumbai', 'Flexible Monthly Cab Plans Mumbai'],
    ['Long-Term Cab Service Mumbai', '']
  ],




"whychoose": [
    {
        "WhyChooseheading": "Flexible Monthly Cab Plans for Mumbai Corporates",
        "WhyChoosedescription": "eTravo offers tailored monthly cab services for companies across Mumbai, helping manage daily employee commutes, executive travel, and business logistics with ease and efficiency."
    },
    {
        "WhyChooseheading": "Fleet Options to Suit Every Department",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and MUVs—depending on your department’s transport needs. Whether it’s for sales teams, top management, or inter-office shuttles, we have the right car."
    },
    {
        "WhyChooseheading": "Chauffeur-Driven and Dedicated Usage Plans",
        "WhyChoosedescription": "Get dedicated chauffeur-driven vehicles for your organization with fixed timings, routes, and reliable drivers who understand Mumbai’s traffic and corporate zones."
    },
    {
        "WhyChooseheading": "Operational Efficiency Without Vehicle Ownership",
        "WhyChoosedescription": "Eliminate the need to buy or lease cars. Our monthly rental model gives you operational flexibility, fixed costs, and the freedom to scale up or down anytime."
    },
    {
        "WhyChooseheading": "Fuel Plans and Cost-Effective Billing Options",
        "WhyChoosedescription": "We offer fuel-inclusive and fuel-exclusive plans based on your company’s preferences. Our transparent billing model ensures clarity for your finance team."
    },
    {
        "WhyChooseheading": "Reliable Drivers with Mumbai Route Expertise",
        "WhyChoosedescription": "All our drivers are background-verified, experienced, and trained in customer service—ensuring on-time arrivals, professional behavior, and smooth coordination in busy Mumbai areas."
    },
    {
        "WhyChooseheading": "GPS Tracking, Live Monitoring, and Reports",
        "WhyChoosedescription": "Track every cab in real time through our centralized dashboard. Access trip reports, usage analytics, and live ETAs to better plan your workforce movement."
    },
    {
        "WhyChooseheading": "GST-Compliant Invoices and Custom Reports",
        "WhyChoosedescription": "eTravo provides monthly billing with detailed trip logs, GST-compliant invoicing, and downloadable reports for audits, reimbursements, and internal accounting."
    }
]
}


const faqData = [
    [
        {
            question: 'What areas in Mumbai do you cover for monthly cab service?',
            answer: 'We cover all zones of Mumbai—South Mumbai, Western and Eastern Suburbs, Navi Mumbai, and Thane for corporate monthly rentals.'
        },
        {
            question: 'Can we choose different vehicles for different teams?',
            answer: 'Yes, you can assign specific vehicles to different departments depending on their travel patterns and comfort requirements.'
        },
        {
            question: 'Are your drivers trained and background verified?',
            answer: 'Absolutely. Our drivers are trained in customer service, route familiarity, and undergo regular background checks and health screening.'
        },
        {
            question: 'Can I upgrade or downgrade the vehicle mid-month?',
            answer: 'Yes, we allow vehicle upgrades, downgrades, or replacements depending on availability. You’re never locked into one model.'
        },
        {
            question: 'Are your rental packages fuel-inclusive?',
            answer: 'We offer both options—fuel-inclusive or fuel-exclusive—based on your internal expense policies and preference.'
        },
        {
            question: 'Do you offer GST billing and digital invoices?',
            answer: 'Yes, we provide monthly GST-compliant invoices and trip summaries, ideal for procurement and accounts departments.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Kunal Parab',
        designation: 'Fleet Manager, Polaris Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s monthly cab services have significantly reduced our transport overhead. The fleet is reliable, and the monthly billing system is a huge plus.”'
    },
    {
        name: 'Ms. Deepa Rane',
        designation: 'Admin Officer, Nexwave Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for monthly executive cabs in Mumbai. The quality of service, vehicle cleanliness, and tracking tools make it a trusted partner for our team.”'
    }
];


















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Service in Mumbai",
  "image": "https://www.etravo.in/images/keyword/monthly-cab-service-mumbai.jpg",
  "description": "Book monthly cab service in Mumbai for corporate employees, long-term hires, and executive transport. Affordable and reliable monthly corporate cab rentals with professional drivers and flexible plans.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8137"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-cab-service-mumbai"
  }
};







    return (
        <div>

<Helmet>
  <title>Monthly Cab Service in Mumbai | Corporate & Executive Monthly Hire | eTravo</title>
  <meta 
    name="description" 
    content="Hire monthly cabs in Mumbai for corporate employees, long-term leases, and executive travel. Reliable and affordable corporate cab rentals by eTravo with flexible plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycabserviceinmumbai;